import axios from 'axios'
import axiosInstance from './axiosInstance'
import keycloak from '../../config/keycloak'

export interface AuthResponse<T = void> {
  success: boolean
  message: string
  data?: T
}

// Fetch permissions for current user's role (legacy flat list — kept for backward compat)
export const getPermissions = async (): Promise<string[]> => {
  const res = await axiosInstance.get<{ data: string[] }>('/auth/permissions')
  return res.data.data
}

// ── User Manager direct call ──────────────────────────────────────────────────
// Calls the User Manager API Gateway directly, forwarding the live Keycloak
// access token as Bearer. No static token — always uses the current session token.

const userManagerInstance = axios.create({
  baseURL: import.meta.env.VITE_USER_MANAGER_BASE_URL as string,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

userManagerInstance.interceptors.request.use((config) => {
  const token = keycloak.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

/**
 * Fetches the full role-menu-action permission tree directly from the
 * User Manager API Gateway using the current Keycloak Bearer token.
 * The roleId comes from the Keycloak token claim (set by authStore).
 */
export const getRoleMenuActions = async (
  roleId: number,
): Promise<import('../../types').MenuActionItem[]> => {
  const res = await userManagerInstance.get<import('../../types').RoleMenuActionResponse>(
    `/api/admin/role_menu_action/${roleId}`,
    // `/${roleId}`,
  )
  return res.data.data ?? []
}
